import {
  getJwtToken,
  decodeJWT,
  getManagedReferralPortfolios,
} from '../../../services/api';

// Brand accents shared with the rest of the Referral section.
export const BRAND_GREEN = '#164B36';
export const BRAND_GOLD = '#FAAF02';
export const FONT_BODY =
  'AvenirRegular, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
export const FONT_HEAVY = 'AvenirHeavy, ' + FONT_BODY;

export const money = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);

export const initialsOf = (nameOrEmail) =>
  String(nameOrEmail || '?')
    .split(/\s+/)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

export function currentUserEmail() {
  try {
    return decodeJWT(String(getJwtToken()))?.email || '';
  } catch (e) {
    return '';
  }
}

// Flatten the /managed response into one row per portfolio.
export function flattenManagedPortfolios(response) {
  const apiClients = (response && response.data && response.data.clients) || [];
  return apiClients.flatMap((client) =>
    (client.portfolios || []).map((portfolio) => ({
      ...portfolio,
      rowId: `${client.id}:${portfolio.id}`,
      portfolioId: portfolio.id,
      clientId: client.id,
      clientName: client.name,
      clientEmail: client.email,
      pendingReviews: client.pendingReviews || 0,
      initials: initialsOf(client.name || client.email),
      product: portfolio.product || 'Smart Crypto',
      // Raw order status kept separately; the headline status reflects whether
      // the referrer is waiting on the client.
      orderStatus: portfolio.status || 'N/A',
      status: client.pendingReviews > 0 ? 'Client approval' : 'On track',
      risk: portfolio.risk || client.risk || 'N/A',
      allocation: Array.isArray(portfolio.allocation) ? portfolio.allocation : [],
      value: Number(portfolio.value) || 0,
    }))
  );
}

export async function loadManagedPortfolios() {
  const response = await getManagedReferralPortfolios();
  return flattenManagedPortfolios(response);
}
